module.exports = __webpack_public_path__ + "media/images/logo-white-bg-4e65131271c078b4c76218b7d2eadba9.png";